module.exports = __webpack_public_path__ + "img/service_rewards.db0b56d5.svg";